export default __webpack_public_path__ + "static/media/search-light.367c194d.svg";